const { registerPlugin } = wp.plugins;
const { useState } = wp.element;
//const { useEffect } = wp.element;
import { useSelect } from '@wordpress/data';

registerPlugin( 'blocksolid-custom-settings-plugin', {
	render() {
		return(<Blocksolid_Plugin />);
	}
} );

const { __ } = wp.i18n;
const { compose } = wp.compose;
const { withSelect, withDispatch } = wp.data;
const { PluginDocumentSettingPanel } = wp.editor;
const { ToggleControl, PanelRow, ButtonGroup, Button } = wp.components;

const blocksolid_field_allow_editor_overlay = jsData.blocksolid_field_allow_editor_overlay; // Blocksolid setting sent from PHP - deprecated
const blocksolid_wordpress_version = jsData.blocksolid_wordpress_version; // Blocksolid setting sent from PHP - deprecated
const blocksolid_current_user_id = jsData.blocksolid_current_user_id; // Blocksolid setting sent from PHP
const blocksolid_current_user_overlay_active = jsData.blocksolid_current_user_overlay_active; // Blocksolid setting sent from PHP
const blocksolid_allow_vc_converter = jsData.blocksolid_allow_vc_converter; // Blocksolid setting sent from PHP

import apiFetch from '@wordpress/api-fetch';

// They made changes to localStorage again in 6.1 so using a user meta field instead now!

const Blocksolid_Plugin = ( { postType, postMeta, setPostMeta } ) => {

	const currentPostId = useSelect( ( select ) => {
	    return select( 'core/editor' ).getCurrentPostId();
	}, [] );

	function check_overlay_feature_active(){
		var feature_value = blocksolid_current_user_overlay_active;
        return(feature_value);
	}

	function check_allow_vc_converter(){

		var feature_value = blocksolid_allow_vc_converter;
        return(feature_value);

	}

	function initiate_vc_converter(){

		var datat = false;

    	wp.apiFetch( {
    		path: 'blocksolid/v1/initiate_vc_converter/'+currentPostId,
    	} ).then( datat => {

			if (datat.message){
				alert(datat.message);
			}

    	} );

    	return true;

	}

	function toggle_overlay_feature_active(){

		var datat = false;

    	wp.apiFetch( {
    		path: 'blocksolid/v1/toggle_overlay_active_setting_rest/'+blocksolid_current_user_id,
    	} ).then( datat => {
    		//console.log( datat );
    	} );

    	return true;

	}

	const [ isChecked, setChecked ] = useState( check_overlay_feature_active() );

	const [ allow_vc_converter ] = useState( check_allow_vc_converter() );

    const overlay_class_name = 'blocksolid-overlay';


	// Function to add class to the body of an iframe
	function add_blocksolid_overlay_class_to_any_iframe_bodies(iframe) {
	    try {
	        if (iframe.contentDocument && iframe.contentDocument.body) {
	            iframe.contentDocument.body.classList.add(overlay_class_name);
	        }
	    } catch (e) {
	        // Handle potential cross-origin errors
	        console.error('Error accessing iframe body:', e);
	    }
	}

	/* NOTE: Currently the iframed mobile and tablet versions only show the overlay if switched on while in them
	   This https://wordpress.stackexchange.com/questions/424575/hook-into-viewport-change suggests there is no clear way around this
	   Potentially we could listen out for changes to canvas size or the value returned by select( 'core/editor' ).getDeviceType() but how to trigger? */

	// Function to add class to the body of an iframe
	function remove_blocksolid_overlay_class_from_any_iframe_bodies(iframe) {
	    try {
	        if (iframe.contentDocument && iframe.contentDocument.body) {
	            iframe.contentDocument.body.classList.remove(overlay_class_name);
	        }
	    } catch (e) {
	        // Handle potential cross-origin errors
	        console.error('Error accessing iframe body:', e);
	    }
	}

    toggle_blocksolid_overlay_class();

    function toggle_blocksolid_overlay_class(blocksolid_wordpress_version) {
        if (isChecked){
            document.body.classList.add(overlay_class_name);
            //Add class to any nested iframe bodies
			document.querySelectorAll('iframe').forEach(add_blocksolid_overlay_class_to_any_iframe_bodies);
        }else{
            document.body.classList.remove(overlay_class_name);
            ///Remove class from any nested iframe bodies
			document.querySelectorAll('iframe').forEach(remove_blocksolid_overlay_class_from_any_iframe_bodies);
        }
    }

    const el = wp.element.createElement;
    const cube = el('svg', { width: 14, height: 14, viewBox:'0 0 512 512', transform:"scale(1.0,1.0)" },
        el('path', { d: "M234.5 5.709C248.4 .7377 263.6 .7377 277.5 5.709L469.5 74.28C494.1 83.38 512 107.5 512 134.6V377.4C512 404.5 494.1 428.6 469.5 437.7L277.5 506.3C263.6 511.3 248.4 511.3 234.5 506.3L42.47 437.7C17 428.6 0 404.5 0 377.4V134.6C0 107.5 17 83.38 42.47 74.28L234.5 5.709zM256 65.98L82.34 128L256 190L429.7 128L256 65.98zM288 434.6L448 377.4V189.4L288 246.6V434.6z" } )
    );

	function blocksolid_toggle_meta() {
		toggle_overlay_feature_active();
        toggle_blocksolid_overlay_class();
        setChecked( ! isChecked );
	}

	const default_content_blocks = '<!-- wp:columns --><div class="wp-block-columns"><!-- wp:column --><div class="wp-block-column"><!-- wp:freeform --><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin accumsan ante nisl, sit amet pharetra nulla fermentum eu. Sed in neque in lectus accumsan scelerisque sed vel nisl. Donec leo dolor, laoreet eget dolor id, consequat dictum dolor. Phasellus nec aliquam sem. Morbi eget consequat metus, non convallis nibh. Aliquam viverra quam at imperdiet egestas. Fusce hendrerit ipsum pharetra ex interdum, id eleifend est dictum. Integer libero nunc, mollis id molestie eget, imperdiet ut diam.</p><!-- /wp:freeform --></div><!-- /wp:column --></div><!-- /wp:columns -->';

	function add_new_blocksolid_row_top() {
		// https://github.com/markhowellsmead/helpers/wiki/Gutenberg-Patterns
		let newBlocks = wp.blocks.rawHandler({HTML: default_content_blocks});
		wp.data.dispatch('core/block-editor').insertBlocks(newBlocks, 0);
		return true;
	}

	function add_new_blocksolid_row_below() {
		let newBlocks = wp.blocks.rawHandler({HTML: default_content_blocks});
		wp.data.dispatch('core/block-editor').insertBlocks(newBlocks, 1);
		return true;
	}

	// Add a space: el("br",{key: 'blocksolid_settings_break_01'}),

	return el( PluginDocumentSettingPanel, {name: 'blocksolid_settings', title: 'Blocksolid', icon: cube, initialOpen:"false"},

		[
			el( PanelRow, {key: 'blocksolid_settings_panelrow'},
				el(ToggleControl, {
					label: __( 'Show desktop overlay' ),
					onChange: ( value ) => blocksolid_toggle_meta(),
					checked: isChecked,
					__nextHasNoMarginBottom: true
				}),
			),

			el(ButtonGroup, { title: '', key: 'blocksolid_settings_buttons' },
	        	el(Button, {
		            key: 'blocksolid_add_new_blocksolid_row_top',
		            value: 'add_row_at_top',
		            title: 'Add row at top',
		            onClick: add_new_blocksolid_row_top,
					isPrimary: false,
		        }, 'Add row at top'),
				el("span",{key: 'blocksolid_settings_space_01'},' '),
	        	el(Button, {
		            key: 'blocksolid_add_new_blocksolid_row_below',
		            value: 'add_row_below',
		            title: 'Add row below',
		            onClick: add_new_blocksolid_row_below,
					isPrimary: false,
		        }, 'Add row below'),
			),

		],

		allow_vc_converter && [

			el("br",{key: 'blocksolid_settings_break_01'}),
			el("br",{key: 'blocksolid_settings_break_02'}),

			el(ButtonGroup, { title: '', key: 'blocksolid_vc_converter_buttons' },
	        	el(Button, {
		            key: 'blocksolid_vc_converter_button',
		            value: 'vc_converter_button',
		            title: 'Clone and convert VC to Gutenberg',
		            onClick: initiate_vc_converter,
					isPrimary: true,
		        }, 'Clone and convert VC to Gutenberg'),
			),

		]

	);
}

export default compose( [] )( Blocksolid_Plugin );